export const navContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.4,
    },
  },
};

export const glitchItem = {
  hidden: {
    opacity: 0,
    scale: 0.9,
  },
  visible: {
    opacity: [0, 1, 0.6, 1],
    x: [0, -6, 6, -3, 3, 0],
    scale: [0.9, 1.1, 1],
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};
